import { actionCreatorFactory } from "typescript-fsa";
import { userdata } from "../typing/table_typing";


const actionCreator = actionCreatorFactory("mytable");

 const resetData = actionCreator<{data:userdata[]}>("MYTABLE_RESETDATA");

 export const TableThingyActions = { resetData}


